<div fxLayout="row" style="margin-bottom: 20px;">
    <button mat-raised-button (click)="back()" class="margin-r">
        <mat-icon>arrow_back</mat-icon>
    </button>
</div>

<div fxLayout="row" fxLayoutWrap="wrap" *ngIf="isLoading">
    <div fxFlex.gt-lg="100" fxFlex.gt-md="100" fxFlex.gt-xs="100" fxFlex="100">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
</div>

<div fxLayout="row" fxLayoutWrap="wrap">
    <div fxFlex.gt-sm="100%" fxFlex="100">
        <mat-card>
            <mat-card-content *ngIf="!processing">
                <mat-horizontal-stepper labelPosition="bottom" #stepper [selectedIndex]="currentStep" [linear]="true">
                    <mat-step *ngFor="let step of riwayatProfile?.progressList; let index = index"
                        [completed]="step.completed === 1 ? true : false">
                        <ng-template matStepLabel>Step {{ (index + 1) }}: {{ step.progressTemplate.title }}
                        </ng-template>
                        <div style="
    width: 100%;
    height: 30px;
    margin-top: 20px;
    background-color: #EEF5F9;
    margin-bottom: 20px;
"></div>
                        <mat-card-title class="center-col">{{ step.progressTemplate.title }}</mat-card-title>
                        <div>
                            <table style="width:100%;">
                                <thead>
                                    <tr>
                                        <td>Deskripsi</td>
                                        <td>Status</td>
                                        <td>View</td>
                                        <td>Hapus</td>
                                        <td>Upload</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of step.progressDetails">
                                        <td>{{ item.progressTemplateDetail.label }}</td>
                                        <td>
                                            <mat-icon *ngIf="!item.completed || item.completed === 0">
                                                check_box_outline_blank</mat-icon>
                                            <mat-icon *ngIf="item.completed && item.completed === 1" color="primary">
                                                check_box</mat-icon>
                                        </td>
                                        <td><button mat-icon-button matTooltip="View/Download"
                                                matTooltipPosition="above" *ngIf="item.filepath && !item.isLoading"
                                                (click)="download(item)">
                                                <mat-icon>remove_red_eye</mat-icon>
                                            </button></td>
                                        <td><button
                                                *ngIf="(tokenStorageService.isAdminKepegawaian() || tokenStorageService.isSuperadmin()) && !item.isLoading"
                                                mat-icon-button matTooltip="Hapus" matTooltipPosition="above"
                                                (click)="confirmDialog(item)">
                                                <mat-icon>delete</mat-icon>
                                            </button></td>
                                        <td><input type="file" class="btn-primary"
                                                *ngIf="(tokenStorageService.isAdminKepegawaian() || tokenStorageService.isSuperadmin() || item.progressTemplateDetail.userUploadEnabled === 1) && !item.isLoading"
                                                (change)="selectFile($event, item)" />
                                            <mat-spinner [diameter]="36" *ngIf="item.isLoading"></mat-spinner>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="button-row m-t-10">
                            <button *ngIf="index !== 0" mat-raised-button color="accent" matStepperPrevious>Step
                                Sebelumnya</button>
                            <button mat-raised-button color="primary"
                                *ngIf="tokenStorageService.isAdminKepegawaian() || tokenStorageService.isSuperadmin()"
                                (click)="confirmCompleteStep(step)">Selanjutnya</button>
                        </div>
                    </mat-step>
                    <mat-step>
                        <ng-template matStepLabel>Done</ng-template>
                        You are now done.
                        <div class="button-row m-t-10">
                            <button mat-raised-button color="primary" matStepperPrevious>Back</button>
                        </div>
                    </mat-step>
                </mat-horizontal-stepper>
            </mat-card-content>
        </mat-card>
    </div>
</div>